export default [
  { id: 'ServiceAgreementDetail', label: 'Service Agreement Maintenance', parent: '' },
];
